import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {PrescriptionTableListeRestApiService} from './prescription-table.liste.rest-api.service';

@Injectable({providedIn: 'root'})
export class PrescriptionTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: PrescriptionTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }
}
